import { render } from "./Tower.vue?vue&type=template&id=2cb8aee3"
import script from "./tower.js?vue&type=script&lang=js&external"
export * from "./tower.js?vue&type=script&lang=js&external"

import "./Tower.vue?vue&type=style&index=0&id=2cb8aee3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__